import axios from "axios";
import Key from "../../../../src/clientVariables.json"
import * as types from "./actiontypes";


export const jsResumeFullDetailsAction = (selectedResume) => async (dispatch) => {
    try {
      const response = await axios.post(
        `${Key.domain}/common/get_js_resume_details`,
        {
          user_id: null,
        resumeid: selectedResume?.resume_id,
          //session_token:  null,
        }
      );
      
      dispatch({
        type: types.JS_FULL_RESUME_DETAILS_SUCCESS,
        payload: response?.data?.data
      });
       return response
    } catch (err) {
      dispatch({
        type: types.JS_FULL_RESUME_DETAILS_FAIL,
        payload: err.message,
      });
    }
  };

  export const ResumeProjectsData = (projects) => (dispatch) => {
    dispatch({ type: types.RESUMES_PROJECTS_DATA, payload: projects });
  
  };

  export const updateSummaryAction = (summary) => ({
    type:  types.UPDATE_SUMMARY,
    payload: summary
  });
  
  export const updateSkillsAction = (skills) => ({
    type:  types.UPDATE_SKILLS,
    payload: skills
  });
  
  export const updatePersonalDetailsAction = (personalDetails) => ({
    type: types.UPDATE_PERSONAL_DETAILS,
    payload: personalDetails
  });
  
  export const updateProjectsAction = (projects) => ({
    type:  types.UPDATE_PROJECTS,
    payload: projects
  });
  
  export const updateEducationDetailsAction = (educationDetails) => ({
    type:  types.UPDATE_EDUCATION_DETAILS,
    payload: educationDetails
  });
  
  export const updateCertificationsAction = (certifications) => ({
    type:  types.UPDATE_CERTIFICATIONS,
    payload: certifications
  });
  
  export const resetResumeAction = () => ({
    type:  types.RESET_RESUME
  });
  
  export const setCurrentSection = (section ,id , isRedirect) => ({ 
    type: types.SET_CURRENT_SECTION,
    payload: {section ,id , isRedirect},
  });
  
 
  export const openInterestedAction = () => ({
    type: types.OPEN_SHARE_INTERESTED,
  });
  
  export const closeInterestedAction = () => ({
    type: types.CLOSE_SHARE_INTERESTED,
  });
  
  
  